import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["backgroundColor", "isContrast"];
let _ = t => t,
  _t;
import Link from '@mui/material/Link';
import * as React from 'react';
import styled from 'styled-components';
import { VarnishContext } from './VarnishContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFooter = styled(_ref => {
  let rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("footer", _extends({}, rest));
})(_t || (_t = _`
  padding: 24px;
  color: ${0};
  text-align: ${0};
  background-color: ${0};
`), ({
  isContrast,
  theme
}) => isContrast ? theme.palette.common.white : theme.palette.common.black, ({
  layout
}) => layout !== 'left-aligned' ? 'center' : null, ({
  backgroundColor,
  isContrast,
  theme
}) => backgroundColor ? backgroundColor.hex : isContrast ? theme.paletteExtended.background.dark.hex : theme.palette.common.white);
export function Footer(props) {
  // TODO: Make custom styles for elements that have standardized padding across AI2
  return /*#__PURE__*/_jsx(VarnishContext.Consumer, {
    children: ({
      layout
    }) => /*#__PURE__*/_jsx(StyledFooter, {
      className: props.className,
      layout: layout,
      backgroundColor: props.backgroundColor,
      isContrast: props.variant === 'dark',
      children: props.children ? props.children : /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(Link, {
          variant: props.variant,
          href: "https://allenai.org",
          children: "\xA9 The Allen Institute for Artificial Intelligence"
        }), ' ', "- All Rights Reserved |", ' ', /*#__PURE__*/_jsx(Link, {
          variant: props.variant,
          href: "https://allenai.org/privacy-policy",
          children: "Privacy Policy"
        }), ' ', "|", ' ', /*#__PURE__*/_jsx(Link, {
          variant: props.variant,
          href: "https://allenai.org/terms",
          children: "Terms of Use"
        }), ' ', "|", ' ', /*#__PURE__*/_jsx(Link, {
          variant: props.variant,
          href: "https://allenai.org/business-code-of-conduct",
          children: "Business Code of Conduct"
        })]
      })
    })
  });
}